import "./App.css";
import { Route, Routes } from "react-router-dom";

import Parents from "../routes/signup/parents/Parents";

import SorryPage from "../components/SorryPage/SorryPage";
import SchoolBase from "../routes/signup/school/SchoolBase";
import { AuthProvider } from "../components/shared/AuthProvider";
import { SignUpProcess } from "../routes/signup/school/SignUpProcess";

import { ParentRegisteration } from "../routes/signup/parents/ParentRegisteration";
import Teachers from "../routes/signup/teacher/Teachers";
import { TeacherRegisteration } from "../routes/signup/teacher/TeacherRegisteration";
import { SkillCoachRegisteration } from "../routes/signup/skillcoaches/SkillCoachRegisteration";
import StudentRegistration from "../routes/signup/students/StudentRegistration";
import PageLayout from "../components/shared/PageLayout";
import SuccessPage from "../components/shared/SuccessPage";
import { ProtectedRoute } from "../components/shared/ProtectedRoute";
import { ToastContainer } from "react-toastify";

import IndexPage from "../routes/signup/index/IndexPage";
import SchoolsWelcome from "../routes/signup/school/SchoolsWelcome";
import Students from "../routes/signup/students/StudentsRouterOutlet";
import StudentsProvider from "../routes/signup/students/context/StudentContext";

function App() {
  return (
    <StudentsProvider>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<IndexPage />} />

          <Route path="/students" element={<Students />}>
            <Route index element={<StudentRegistration />} />
          </Route>

          <Route path="/parents" element={<Parents />}>
            <Route index element={<ParentRegisteration />} />
          </Route>

          <Route path="/schools" element={<SchoolBase />}>
            <Route index element={<SchoolsWelcome />} />

            <Route
              path="signup-process"
              element={
                <ProtectedRoute>
                  <SignUpProcess />
                </ProtectedRoute>
              }
            />
          </Route>

          <Route path="/teachers" element={<Teachers />}>
            <Route index element={<TeacherRegisteration />} />
          </Route>

          <Route element={<PageLayout />}>
            <Route path="/sorry" element={<SorryPage />} />
            <Route path="/success" element={<SuccessPage />} />
          </Route>
        </Routes>
      </AuthProvider>
      <ToastContainer />
    </StudentsProvider>
  );
}

export default App;
